import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import Reveal, { MaskedLines } from './Reveal';

export default function PageHero({ eyebrow, title, intro, crumbs = [], testid }) {
  return (
    <header className="border-b border-hairline bg-offwhite bg-blueprint-light">
      <div className="mx-auto max-w-7xl px-4 pb-14 pt-32 sm:px-6 sm:pb-20 sm:pt-40 lg:px-8">
        {crumbs.length > 0 && (
          <nav aria-label="Breadcrumb" className="mb-8">
            <ol className="flex flex-wrap items-center gap-1.5 text-xs text-stonebrand">
              <li>
                <Link to="/" className="transition-colors hover:text-charcoal" data-testid="breadcrumb-home">
                  Home
                </Link>
              </li>
              {crumbs.map((c) => (
                <li key={c.label} className="flex items-center gap-1.5">
                  <ChevronRight className="h-3 w-3" aria-hidden="true" />
                  <span aria-current="page" className="text-charcoal">{c.label}</span>
                </li>
              ))}
            </ol>
          </nav>
        )}
        {eyebrow && (
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-stonebrand">{eyebrow}</p>
        )}
        <MaskedLines
          lines={[title]}
          testid={testid}
          className="mt-4 max-w-4xl text-balance font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-charcoal sm:text-5xl lg:text-6xl"
        />
        {intro && (
          <Reveal delay={0.25}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-stonebrand sm:text-lg">{intro}</p>
          </Reveal>
        )}
      </div>
    </header>
  );
}
